import { DeleteProductUpdateSubscriptionsDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteProductUpdatesSubscriptions = () => {
  const [deleteSubscription, { loading, called }] = useMutation(
    DeleteProductUpdateSubscriptionsDocument,
    {
      extractorFn: (data) => data.productUpdatesMutations.deleteProductupdatesSubscription,
    }
  )

  return {
    loading,
    called,
    deleteSubscription,
  }
}
